import Box from "@mui/material/Box";
import { Backdrop, CircularProgress } from "@mui/material";

function FullPageLoader({ loading }: { loading: boolean }) {
  return (
    <Box data-testid="full-page-loader">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
    </Box>
  );
}

export default FullPageLoader;
